import React from "react";
import { Dropdown } from "react-bootstrap";
import { FaGlobe } from "react-icons/fa";
import { useLanguage } from "../context/LanguageContext";

// Globe dropdown for the navbar. Renders nothing when the multi-language module
// is off this store's plan or only one language is enabled.
const LanguageSwitcher = () => {
  const { enabled, languages, supported, current, change } = useLanguage();
  if (!enabled || languages.length < 2) return null;

  const label = (code) => supported.find((l) => l.code === code)?.label || code.toUpperCase();

  return (
    <Dropdown align="end" className="user-dd lang-dd">
      <Dropdown.Toggle aria-label="Language">
        <FaGlobe />
        <span className="lang-code">{current.toUpperCase()}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {languages.map((code) => (
          <Dropdown.Item key={code} active={code === current} onClick={() => change(code)}>
            {label(code)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSwitcher;
